import getDefaultComposeContentBlock from './getDefaultComposeContentBlock';
import convertInlineCss from 'roosterjs-editor-dom/lib/utils/convertInlineCss';
export default function buildReplyForwardMessageBody(body, bodyType) {
    var newBody = bodyType == 'HTML' ? getDefaultComposeContentBlock() : '\n';
    if (body) {
        if (bodyType == 'HTML') {
            body = convertInlineCss(body);
        }
        newBody = newBody + body;
    }
    return newBody;
}
//# sourceMappingURL=buildReplyForwardMessageBody.js.map